/**
 * Item 2 — bulk-import shipping-rule flow.
 *
 * Small presentational tag that surfaces the shipping rule which produced a
 * bulk-import preview row's recommended carrier. The backend sets
 * `recommended_rule_name` on the import row ONLY when a rule actually matched
 * — so when the prop is empty we render nothing (no fabricated rule name).
 *
 * The recommended carrier itself and the "other eligible carriers" popover
 * are rendered separately off `available_carriers_detail`; this component
 * only adds the rule-name affordance next to them.
 */

interface ImportRuleLabelProps {
  /** `recommended_rule_name` from the import row; null/empty => render nothing. */
  ruleName?: string | null;
  /** i18n translator (passed in so this stays a pure, easily-tested component). */
  t: (key: string) => string;
}

export function ImportRuleLabel({ ruleName, t }: ImportRuleLabelProps) {
  const name = ruleName?.trim();
  if (!name) return null;

  return (
    <span
      title={`${t('import_rule_label')} ${name}`}
      className='mt-0.5 inline-flex max-w-[160px] items-center gap-1 truncate rounded-md bg-[hsl(150,55%,94%)] px-1.5 py-0.5 text-[10px] font-medium text-[hsl(150,55%,28%)]'
    >
      <span className='shrink-0 opacity-70'>{t('import_rule_label')}</span>
      <span className='truncate'>{name}</span>
    </span>
  );
}
